import { ReactNode } from 'react';

import { Breadcrumbs } from 'types/breadcrumbs';

import Page from './Page';
import { NavlinkKey } from '../Navbar';

import './PageRightSidebar.scss';

interface PageRightSidebarProps {
  children?: ReactNode;
  className?: string;
  activeNavlink?: NavlinkKey;
  breadcrumbs?: Breadcrumbs;
}

export default function PageRightSidebar({
  children,
  className = '',
  activeNavlink,
  breadcrumbs,
}: PageRightSidebarProps) {
  return (
    <Page className={`page-right-sidebar ${className}`} activeNavlink={activeNavlink} breadcrumbs={breadcrumbs}>
      {children}
    </Page>
  );
}
